import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
} from 'intact';
import {BubbleList, Button} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', [
            _$cc(Button, {
                'ev-click': this.clear,
                'children': '清空消息'
            }),
            _$cc(Button, {
                'ev-click': this.restore,
                'children': '恢复消息'
            })
        ], 4, 'bubble-list-demo-empty-actions'),
        _$cc(BubbleList, {
            'className': 'bubble-list-demo-empty-list',
            'items': this.get('items'),
            'roles': this.get('roles'),
            '$blocks': function($blocks) {
                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                return (
                    (
                        (_$blocks['empty'] = function($super) {
                            return (
                                _$ce(2, 'div', [
                                    _$ce(2, 'div', '还没有会话内容', 16, 'bubble-list-demo-empty-title'),
                                    _$ce(2, 'div', '你可以先发送一条消息，或从推荐问题开始。', 16, 'bubble-list-demo-empty-desc')
                                ], 4, 'bubble-list-demo-empty-state')
                            );
                        }),
                        (__$blocks['empty'] = function($super, data) {
                            var block = $blocks['empty'];
                            var callBlock = function() {
                                return _$blocks['empty'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    __$blocks
                );
            }.call($this, _$em)
        })
    ], 4, 'bubble-list-demo-empty');
};